import script from "./ArchiveView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchiveView.vue?vue&type=script&setup=true&lang=ts"

import "./ArchiveView.vue?vue&type=style&index=0&id=5e6ce035&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e6ce035"]])

export default __exports__